import { render, staticRenderFns } from "./kjqg.vue?vue&type=template&id=4d0fb9bb&scoped=true&"
import script from "./kjqg.vue?vue&type=script&lang=js&"
export * from "./kjqg.vue?vue&type=script&lang=js&"
import style0 from "./kjqg.vue?vue&type=style&index=0&lang=less&"
import style1 from "./kjqg.vue?vue&type=style&index=1&id=4d0fb9bb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0fb9bb",
  null
  
)

export default component.exports